export default __webpack_public_path__ + "static/media/ico-check-white.d94146a3.svg";